(function (sb) {
	var me = (sb.DynamicImageCache = {});
	var imageDataCache = {};
	var thumbNavFlagCache = {};	

	me.setImageDataToCache = function (data, id) {

		imageDataCache[id] = data;
	}
	me.getImageDataFromCache = function (id) {
		return imageDataCache[id];
	}
	me.setThumbNavFlag = function (flag, id) {
		thumbNavFlagCache[id] = flag;
	}

	me.getThumbNavFlag = function (id) {
		return thumbNavFlagCache[id];
	}
	
})(window.Storyboard = (window.Storyboard || {}));
window.DynamicImageSetup = {
	setupEditPanel: function (contentElement) {
        $.when(DynamicImageSetup.loadFilters(), DynamicImageSetup.getDynamicImageSettings(contentElement))
         .done(function (r1, r2) {
            DynamicImageSetup.bindFilters(r1[0].d);
            DynamicImageSetup.bindDISettings(r2[0].d);
            $("#DUI-ST-SAVESETTINGS").removeAttr("disabled");
        });
	},
    getDynamicImageSettings: function (contentElement) {
        return Helpers.perfJSonCall({ method: 'GetDynamicImageSettings', data: { contentElement: contentElement } });
	},
	saveSetup: function (layoutElementItem) {

		var leguid = "";

		var imageLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
		leguid = imageLayoutElem.guid;

		var dynamicImageData = DynamicImageSetup.getDynamicImageSettingsData(leguid);
		Helpers.performJSonCall2('SaveDynamicImageSettings'
			, { targetLayoutElement: layoutElementItem,
				settings: dynamicImageData
			}
			, function (res) {
				
			});
	},
	loadTabs: function () {
		$("#dynimagetabholder").tabs("destroy");
		$('#dynimagetabholder').removeClass('ui-widget');
		$("#dynimagetabholder").tabs();
		//todo set styles for line style drop down and border type radio
	},
	bindFilters: function (filterArray) {

		var template = $("#diFilterBox > .difilterboxTemplate");
		template.show();
		Storyboard.GuiEvents.bindFilters(filterArray, "diFilterBox", "difilterboxTemplate", false);
		Storyboard.GuiEvents.bindOptionalFilters(filterArray, "optFilterBoxDI", "optionFilterTemplateDI", "optionalFilterSettingsDI");
		Storyboard.GuiEvents.bindOptionalFiltersCheckAll("optFilterBoxDI");
		template.hide();

	},
	loadFilters: function () {
		return Helpers.perfJSonCall({ method: 'GetFilters', fixCasing: true });
	},
	bindDISettings: function (settings) {
		if (settings != undefined) {
			$("#diTimeSelections").find(".tpcDropDown").val(settings.TimePeriod);
			if (settings.TimePeriod === 0)
				$("#diTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").show();
			else
			    $("#diTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").hide();
		    
			if (settings.TimePeriod === 0)
			    $("#diTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").show();
			else
			    $("#diTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").hide();
			if (settings.TimePeriod === 27)
			    $("#diTimeSelections").find("#txtTimePeriod, #ddlTimePeriodSpan").show();
			else
			    $("#diTimeSelections").find("#txtTimePeriod, #ddlTimePeriodSpan").hide();

			if (settings.StartEndPeriod) {
				$("#diTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStartDate));
				$("#diTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStopDate));
			} else {
				$("#diTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.strToDate($("#diTimeSelections").find(".dateInputStart").attr("defaultdate")));
				$("#diTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.strToDate($("#diTimeSelections").find(".dateInputStop").attr("defaultdate")));
			}

			$("#diTimeSelections").find("#txtTimePeriod").val(settings.TimePeriodSpanAmount);
			$("#diTimeSelections").find("#ddlTimePeriodSpan").val(settings.TimePeriodSpan);


			$('#cbImageScreenshot').attr('checked', settings.ScreenShotImage);
			$('#cbImagePerSlide').attr('checked', settings.ImagesPerSlide != null);
			if (settings.ImagesPerSlide != null) {
				$("#txtdiMaxImages").val(settings.ImagesPerSlide);
			}
			$("#cbImagePerSlide").change();
			$('#cbdiAggregateOnline').attr('checked', settings.AggregateOnline);
			$('#cbdiAggregatePPT').attr('checked', settings.AggregateInPPT);
			if (settings.ShowHFilterSettings)
				$("#diHFilterSettings").show();
			else
				$("#diHFilterSettings").hide();
			DynamicImageSetup.setSelectedFilters(settings.Filters);
			DynamicImageSetup.setOptionalFilterSettings(settings.OptionalFilterSettings);
		}
    },
    setOptionalFilterSettings: function (optionalFilterSettings) {
		if (optionalFilterSettings) {
			optionalFilterSettings.forEach(function (ofs) {
                if (!ofs.OptionalSettingType) return;
                if (ofs.OptionalSettingType == 2) {
                    $("#chkOptHFilterDI").attr("checked", ofs.IsApply);
                }
                else if (ofs.OptionalSettingType == 3) {
                    DynamicImageSetup.setOptionalFilterQuestions(ofs.QuestionID, ofs.IsApply);
                }
                else if (ofs.OptionalSettingType == 4) {
                    $("#chkOptTimePeriodDI").attr("checked", ofs.IsApply);
                }
            });
        }

        var allChecked = $('#optionalFilterSettingsDI input[type="checkbox"]')
            .filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
            .filter(function() { return !$(this).is(':checked'); })
            .length === 0;

        $('#optionalFilterSettingsDI')
            .prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
            .attr('checked', allChecked);
    },
    setOptionalFilterQuestions: function (questionId, isApply) {
        $("#optFilterBoxDI div").each(function () {
            if (questionId == parseInt($(this).find("#hidOptQuestionId").val() || "0")) {
                $(this).find(".chkOptFilterDI").attr("checked", isApply);
            }
        });
    },
	getDynamicImageSettingsData: function (layoutElementGuid) {
		var data = {};
		if (layoutElementGuid != undefined && layoutElementGuid != "") {
			var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
			data.LayoutElementGuid = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.DYNAMICIMAGE, le).guid;
			data.SettingId = le.layoutElementId; //will be set to the elementItemID on the server side
		}
		else //preview mode
		{
			data.LayoutElementGuid = "";
			data.SettingId = 0;
		}
		data.TimePeriod = DynamicImageSetup.getTimePeriod().timePeriod;
		data.TimePeriodSpan = DynamicImageSetup.getTimePeriod().timePeriodSpan;
		data.TimePeriodSpanAmount = DynamicImageSetup.getTimePeriod().timePeriodSpanAmount;
		data.StartEndPeriod = DynamicImageSetup.getStartEndPeriod();
		data.ScreenShotImage = DynamicImageSetup.getScreenShotImage();
		data.ImagesPerSlide = DynamicImageSetup.getImagesPerSlide();
		data.AggregateOnline = DynamicImageSetup.getAggregateOnline();
		data.AggregateInPPT = DynamicImageSetup.getAggregateInPPT();
		data.Filters = DynamicImageSetup.getFilters();
		data.OptionalFilterSettings = DynamicImageSetup.getOptionalFilterSetting(data.SettingId);
		return data;
    },
    getOptionalFilterSetting: function (settingId) {
        var optFilterSettings = [];

        var rowHFilter = new Object();
        rowHFilter.SettingId = parseInt(settingId || "0");
        rowHFilter.OptionalSettingType = 2;
        rowHFilter.IsApply = $("#chkOptHFilterDI").is(':checked');
        optFilterSettings.push(rowHFilter);

        $("#optFilterBoxDI div").each(function () {
            var rowFilter = new Object();
            rowFilter.SettingId = parseInt(settingId || "0");
            rowFilter.FilterID = parseInt($(this).find("#hidOptFilterId").val() || "0");
            rowFilter.QuestionID = parseInt($(this).find("#hidOptQuestionId").val() || "0");
            rowFilter.OptionalSettingType = 3;
            rowFilter.IsApply = $(this).find(".chkOptFilterDI").is(':checked');
            if (rowFilter.FilterID > 0)
                optFilterSettings.push(rowFilter);
        });

        var rowTimePeriod = new Object();
        rowTimePeriod.SettingId = parseInt(settingId || "0");
        rowTimePeriod.OptionalSettingType = 4;
        rowTimePeriod.IsApply = $("#chkOptTimePeriodDI").is(':checked');
        optFilterSettings.push(rowTimePeriod);

        return optFilterSettings;
    },
	getTimePeriod: function () {
	    var timePeriod = {};
	    timePeriod.timePeriod = $("#diTimeSelections").find(".tpcDropDown").val() || 0;
	    timePeriod.timePeriodSpan = $("#diTimeSelections").find("#ddlTimePeriodSpan").val() || 1;
	    timePeriod.timePeriodSpanAmount = $("#diTimeSelections").find("#txtTimePeriod").val() || 0;
	    return timePeriod;
	},
	getStartEndPeriod: function () {
		var timeStartEnd = {};
		timeStartEnd.startDate = Helpers.formatDate($("#diTimeSelections").find('.dateInputStart').datepicker('getDate'));
		timeStartEnd.stopDate = Helpers.formatDate($("#diTimeSelections").find('.dateInputStop').datepicker('getDate'));
		return timeStartEnd;
	},
	getScreenShotImage: function () {
		return $("#cbImageScreenshot").is(':checked');
	},
	getImagesPerSlide: function () {
		var isUsePerSlide = $("#cbImagePerSlide").is(':checked');
		var usePerSlide = null;
		if (isUsePerSlide) {
			var txtval = $("#txtdiMaxImages").val();
			var i = parseInt(txtval);
			if (!isNaN(i)) {
				usePerSlide = i;
			}
		}
		return usePerSlide;
	},
	getAggregateOnline: function () {
		return $("#cbdiAggregateOnline").is(':checked');
	},
	getAggregateInPPT: function () {
		return $("#cbdiAggregatePPT").is(':checked');
	},
	setSelectedFilters: function (filterArray) {
		HTMLHelpers.setSelectedValues($("#diFilterBox div select"), 0);
		if (filterArray) {
			filterArray.forEach(function(filter) {
				if (!filter.FilterID) return;
				var filterbox = $("#diFilterBox div #hidFilterId[value='" + filter.FilterID + "']").parent();
	
				if (filter.AllAnswers)
					HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
				else {
					var answerIds = $.map(filter.Answers, function (e) { return isNaN(e.AnswerID) ? e : e.AnswerID });
					HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
				}
			});
		}
	},
	getFilters: function () {
		var filters = [];

		$("#diFilterBox > div:not(.difilterboxTemplate)").each(function () {
			var filterId = $(this).find("#hidFilterId").val();
            var questionId = $(this).find('#hidQuestionId').val();
            var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

            var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
                filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).map(function () {
				return { answerId: $(this).val(), answerText: $(this).text() };
			}).toArray();

			var filterText = $(this).find('h3').text();

			if ($(selectedAnswers).length > 0) {
				var Filter = {
					FilterID: filterId,
					Answers: selectedAnswers,
					Compare: false,
					QuestionID: questionId,
                    FilterText: filterText,
                    AllAnswers: allAnswers
				};

				filters.push(Filter);
			}
		});

		return filters;
	},
	redrawDynamicImage: function (dynamicImageLayoutElementItem) {
		if (dynamicImageLayoutElementItem != null) {
			dynamicImageLayoutElementItem.content = '';
			if (dynamicImageLayoutElementItem.guid != "") {//element already has been saved                 
				var imageDataDiv = $(".layoutElementItem[guid='" + dynamicImageLayoutElementItem.guid + "']");
				$(imageDataDiv).empty();
				$(imageDataDiv).html('<div class="layoutElementDynamicImageData"></div>');
				var galleryDiv = $(imageDataDiv).find(".layoutElementDynamicImageData");

				var imageData = Storyboard.DynamicImageCache.getImageDataFromCache(dynamicImageLayoutElementItem.guid);
				this.renderGallery(imageDataDiv, galleryDiv, imageData, dynamicImageLayoutElementItem.guid, false,
                    dynamicImageLayoutElementItem.width, dynamicImageLayoutElementItem.height);
			}
		}
	},
	eventUpdateDynamicImage: function (layoutElement, imageData) {
		var imageElem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.DYNAMICIMAGE, layoutElement);
		var imageDiv = $(".layoutElement[guid='" + layoutElement.guid + "']").find(".layoutElementDynamicImage")[0];
		if (imageDiv != undefined) {
			$(imageDiv).empty();
			if ($(imageDiv).is(':empty')) {
				$(imageDiv).html('<div class="layoutElementDynamicImageData"></div>');
				var gallery = $(imageDiv).find(".layoutElementDynamicImageData");
			}

			this.renderGallery(imageDiv, gallery, imageData, imageElem.guid, false, imageElem.width, imageElem.height);   //todo load settings from db  
			this.saveDynamicImageHtml(imageDiv, imageElem);

			if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
				var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
				Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
			}
		}
	},
	renderGallery: function (imageDiv, galleryDiv, imageData, elementItemGuid, isPlaySlideShow, width, height) {
		if (imageData == undefined || imageData == null) {
			return;
		}
		DynamicImageSetup.createGalleryHtmlTemplate(imageData, galleryDiv, width, height);
		if (imageData.PictCount > 1) {
			galleryDiv.find("ul.thumbs img").click(function () {
				Storyboard.DynamicImageCache.setThumbNavFlag(true, elementItemGuid);
			});

			galleryDiv.find('div.image_content').css('display', 'block');
			var onMouseOutOpacity = 0.67;
			//if we reinitialize gallery, but slideshow runs, display pause button
			if (isPlaySlideShow) {
				$(imageDiv).find('a.slideshow-button').removeClass("play");
				$(imageDiv).find('a.slideshow-button').addClass("pause");
			}
			var elementItemSelector = ".layoutElementItem[guid='" + elementItemGuid + "']";
			// Initialize Advanced Galleriffic Gallery
			var gallery = galleryDiv.find("#thumbs").galleriffic({
				delay: 2500,
				numThumbs: 7,
				preloadAhead: 7,
				enableTopPager: false,
				enableBottomPager: false,
				imageContainerSel: elementItemSelector + " .slideshow-content",
				loadingContainerSel: elementItemSelector + " .image_loader",
				renderSSControls: false,
				renderNavControls: false,
				playLinkText: 'Play',
				pauseLinkText: 'Pause',
				prevLinkText: '&lsaquo; Previous Photo',
				nextLinkText: 'Next Photo &rsaquo;',
				nextPageLinkText: 'Next &rsaquo;',
				prevPageLinkText: '&lsaquo; Prev',
				enableHistory: false,
				autoStart: isPlaySlideShow,
				syncTransitions: true,
				defaultTransitionDuration: 900,
				onSlideChange: function (prevIndex, nextIndex) {
					// 'this' refers to the gallery, which is an extension of $('#thumbs')
					if (this == undefined) {
						return;
					}
					this.find('ul.thumbs').children()
							.eq(prevIndex).fadeTo('fast', onMouseOutOpacity).end()
							.eq(nextIndex).fadeTo('fast', 1.0);

					//if slideshow was stopped by smth reasons, remove pause button
					if (!this.isSlideshowRunning) {
						if ($(imageDiv).find('a.slideshow-button').hasClass("pause")) {
							$(imageDiv).find('a.slideshow-button').removeClass("pause");
							$(imageDiv).find('a.slideshow-button').addClass("play");
						}
					}
					else {//if slideshow paused and continue after next page downloaded, add pause button
						if ($(imageDiv).find('a.slideshow-button').hasClass("play")) {
							$(imageDiv).find('a.slideshow-button').removeClass("play");
							$(imageDiv).find('a.slideshow-button').addClass("pause");
						}
					}
					// Update the photo index display

					var flagNav = Storyboard.DynamicImageCache.getThumbNavFlag(elementItemGuid);
					Storyboard.DynamicImageCache.setThumbNavFlag(undefined, elementItemGuid); //clear flag in cache
					if (prevIndex == (this.data.length - 1) && nextIndex == 0) {//try to load image from the next page
						if (flagNav == undefined) {
							this.find('a.next').click();
						}
					}
					if (prevIndex == 0 && nextIndex == (this.data.length - 1)) {//try to load image from the previous page                        
						if (flagNav == undefined) {
							this.find('a.prev').click();
						}
					}
				},
				onPageTransitionOut: function (callback) {
					this.fadeTo('fast', 0.0, callback);
				},
				onPageTransitionIn: function () {
					//clear width and heght attributes from current img to correct display it with css
					galleryDiv.find("a.advance-link img").removeAttr("width");
					galleryDiv.find("a.advance-link img").removeAttr("height");
					var prevPageLink = this.find('a.prev').css('visibility', 'hidden');
					var nextPageLink = this.find('a.next').css('visibility', 'hidden');

					// Show appropriate next / prev page links

					if (imageData.CurrentPage > 0) {
						prevPageLink.css('visibility', 'visible');
					}

					if (imageData.CurrentPage < imageData.PagesCount) {
						nextPageLink.css('visibility', 'visible');
					}

					this.fadeTo('fast', 1.0);
				},
				onTransitionIn: function (slide, caption, isSync) {
					//clear width and heght attributes from current img to correct display it with css
					galleryDiv.find("a.advance-link img").removeAttr("width");
					galleryDiv.find("a.advance-link img").removeAttr("height");
					var duration = this.getDefaultTransitionDuration(isSync);
					slide.fadeTo(duration, 1.0);
				}
			});

			/**************** Event handlers for custom next / prev page links **********************/

			var elemGuid = $(imageDiv).closest('.layoutElement').attr('guid');
			var dynamicImageLayoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(elemGuid);
			gallery.find('a.prev').click(function (e) {
				var isPlaySlideshow = false;
				if (gallery.isSlideshowRunning) {
					isPlaySlideshow = true;
					gallery.pause();
				}
				gallery = undefined; //destroy old slideshow
				var prevPageNumber = imageData.CurrentPage - 1;
				DynamicImageSetup.getImageFromServer(dynamicImageLayoutElement, prevPageNumber, isPlaySlideshow);
				e.preventDefault();
			});

			gallery.find('a.next').click(function (e) {
				var isPlaySlideshow = false;
				if (gallery.isSlideshowRunning) {
					isPlaySlideshow = true;
					gallery.pause();
				}
				gallery = undefined; //destroy old slideshow
				var nextPageNumber = imageData.CurrentPage + 1;
				if (nextPageNumber > imageData.PagesCount) {
					nextPageNumber = 0; //goto beginning
				}
				DynamicImageSetup.getImageFromServer(dynamicImageLayoutElement, nextPageNumber, isPlaySlideshow);
				e.preventDefault();
			});

			//--------------event handler for custom play/pause button----------------//
			$(imageDiv).find('a.slideshow-button').click(function (e) {
				if (gallery.isSlideshowRunning) {
					gallery.pause();
					$(imageDiv).find('a.slideshow-button').removeClass("pause");
					$(imageDiv).find('a.slideshow-button').addClass("play");
				}
				else {
					gallery.play();
					$(imageDiv).find('a.slideshow-button').removeClass("play");
					$(imageDiv).find('a.slideshow-button').addClass("pause");
				}
			});
		}
		//set html to chache for redraw
		Storyboard.DynamicImageCache.setImageDataToCache(imageData, elementItemGuid);
	},
	getImageFromServer: function (dynamicImageLayoutElement, pageNumber, isPlaySlideshow) {
		var genSettings = GeneralSettings.getSelectedSettings();
		Helpers.performJSonCall2('getDynamicImagePageNumber'
			, { layoutElement: dynamicImageLayoutElement,
				settings: genSettings,
				pageNumber: pageNumber
			}
			, function (imageData) {
				var dynamicImageLayoutElementItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.DYNAMICIMAGE, dynamicImageLayoutElement);
				if (dynamicImageLayoutElementItem != null && imageData != undefined) {
					dynamicImageLayoutElementItem.content = '';
					if (dynamicImageLayoutElementItem.guid != "") {//element already has been saved                
						var imageDataDiv = $(".layoutElementItem[guid='" + dynamicImageLayoutElementItem.guid + "']");
						if (imageDataDiv != undefined) {
							$(imageDataDiv).empty();
							$(imageDataDiv).html('<div class="layoutElementDynamicImageData"></div>');
							var galleryDiv = $(imageDataDiv).find(".layoutElementDynamicImageData");
							DynamicImageSetup.renderGallery(imageDataDiv, galleryDiv, imageData, dynamicImageLayoutElementItem.guid, isPlaySlideshow,
                               dynamicImageLayoutElementItem.width, dynamicImageLayoutElementItem.height);
						}
					}
				}
			});
	},
	createGalleryHtmlTemplate: function (imageData, imageDiv, width, height) {
		var htmlTemplate = "";
		if (imageData == null || imageData.PictCount == 0) {
			// imageData.DataContent[0][0] causes null reference!
		    //$(imageDiv).html(imageData.DataContent[0][0]); //"no data" text
		}
		else
			if (imageData.PictCount == 1) {
				htmlTemplate = '<img src="' + imageData.DataContent[0][0] + '&width=' + width + '&height=' + height + '&thumb=true&copr=1" alt="' + imageData.DataContent[0][1] + '" class="dynamic-image-single"/>';
				$(imageDiv).html(htmlTemplate);
			}
			else {
				htmlTemplate = $(".diGalleryTemplate").html();
				$(imageDiv).html(htmlTemplate);
				var liTemplate = $(imageDiv).find("li").clone(); //find template for li element (singel gallery item)
				$(imageDiv).find("li").remove();
				for (var imageInfo in imageData.DataContent) {
					var url = imageData.DataContent[imageInfo][0];
					var thumbUrl = url + "&width=45&height=45&thumb=true";
					var bigPictHeight = height > 56 ? height - 56 : 0;
					var bigPictUrl = url + "&width=" + width + "&height=" + bigPictHeight + "&thumb=true&copr=1";
					var fileName = imageData.DataContent[imageInfo][1];
					var lielem = $(liTemplate).clone();
					$(lielem).find("a").attr("name", fileName);
					$(lielem).find("a").attr("href", bigPictUrl);
					$(lielem).find("a").attr("title", fileName);
					$(lielem).find("img").attr("src", thumbUrl);
					$(lielem).find("img").attr("alt", fileName);
					$(imageDiv).find("ul").append(lielem);
				}
			}
	},
	saveDynamicImageHtml: function (imageDiv, imageElemItem) {
		var imageClone = $(imageDiv).clone();
		var htmlContent = $(imageClone).html();
		$(imageClone).remove();
		imageElemItem.content = htmlContent;
	}
};
